import { ComponentTypes } from '@wix/editor-const';

export const IFRAME_WIDGET = 'WIDGET';
export const IFRAME_PAGE = 'PAGE';
export const BUILDER_WIDGET = 'EDITOR_REACT_COMPONENT';
export const OOI_WIDGET = 'WIDGET_OUT_OF_IFRAME';
export const OOI_PAGE = 'PAGE_OUT_OF_IFRAME';
export const BLOCKS_WIDGET = 'STUDIO_WIDGET';
export const CE_WIDGET = 'CUSTOM_ELEMENT_WIDGET';
export const VIRTUAL_OOI_SLOT_SEPARATOR = '_vs_';
export const SLOT_ID_DIVIDER = '_r_';
export const DEFAULT_BLOCKS_SLOT_KEY_NAME = 'slot';

export const SUPPORTED_PLUGIN_COMPONENT_TYPES = [
  ComponentTypes.RefComponent,
  ComponentTypes.TpaWidget,
  ComponentTypes.CustomElement,
];

export const SUPPORTED_HOST_PLUGIN_COMPONENT_TYPES = [
  ComponentTypes.TpaWidget,
  ComponentTypes.TpaSection,
  ComponentTypes.TpaMultiSection,
];

export enum ComponentPreviewState {
  HIGHLIGHTED = 'highlighted',
}
